<div class="footer-inner">
    <div class="footer__button-wrapper">
        <app-button
                [cssClasses]="'extra-large-btn solid__blue-02'"
                [icon]="'arrow_back'"
                [disabled]="backButtonDisabled"
                [hideLabelMobileOnly]="true"
                [ariaLabel]="('GENERAL.BACK' | translate) + ('GENERAL.BUTTON' | translate)"
                (buttonClicked)="onBackClick()">
            {{'GENERAL.BACK' | translate }}
        </app-button>
    </div>
    <div class="footer__button-wrapper">
        <app-checkbox
                [checked]="unitMarkedWithQuestion"
                [cssClass]="'checkbox-btn'"
                [ariaLabel]="((innerWidth < 768 ? 'BASIC_MODE.QUESTION_TEXT_SMALL' : 'BASIC_MODE.QUESTION_TEXT_LARGE') | translate) + ('GENERAL.CHECK' | translate) + ('GENERAL.BUTTON' | translate)"
                [label]="(innerWidth < 768 ? 'BASIC_MODE.QUESTION_TEXT_SMALL' : 'BASIC_MODE.QUESTION_TEXT_LARGE') | translate"
                [disableRipple]="true"
                (changeEvent)="emitQuestionEvent.emit()">
        </app-checkbox>
    </div>
    <div class="footer__button-wrapper" *ngIf="!displayFinish">
        <app-button
                [cssClasses]="'extra-large-btn solid__mint-07'"
                [icon]="'arrow_forward'"
                [hideLabelMobileOnly]="true"
                [ariaLabel]="('GENERAL.CONTINUE' | translate) + ('GENERAL.BUTTON' | translate)"
                (buttonClicked)="onNextClick()">
            {{'GENERAL.CONTINUE' | translate}}
        </app-button>
    </div>

    <div class="footer__button-wrapper" *ngIf="displayFinish">
        <app-button
                [cssClasses]="'extra-large-btn solid__green-03'"
                [icon]="'done'"
                [hideLabelMobileOnly]="true"
                [ariaLabel]="('GENERAL.SAVE_AND_CONTINUE' | translate) + ('GENERAL.BUTTON' | translate)"
                (buttonClicked)="onCompleteClick()">
            {{'GENERAL.SUBMIT' | translate}}
        </app-button>
    </div>
</div>
